// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qs-5";
export var filledCircle = "_qs-4";
export var historyEntry = "_qs-3";
export var messageSideLeft = "_qs-1";
export var messageSideRight = "_qs-2";
export var orderTrackingCarouselWrapper = "_qs-6";
export var orderTrackingInfoContainer = "_qs-0";